export const TOAST_MESSAGE_TYPES = {
  SUCCESS: 'success',
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
  LOADING: 'loading'
};
